// extracted by css-extract-rspack-plugin
export default {"granetCodeEditor":"granetCodeEditor__H47Rj"};